export enum SIFAuthModes {
    Basic = "BASIC",
    HMAC = "HMAC",
}

class SIFIntegration {
    id: number;
    campusID: number;
    termDatesID: number;
    schoolID: number;

    createdBy: number;
    createdOn: Date;
    editedBy: number;
    editedOn: Date;
    recycledBy?: number;
    recycledOn?: Date;

    name: string;
    providerURL: string;
    applicationKey: string;
    sharedSecret: string;
    environmentToken: string;
    sessionToken: string;
    userToken: string;
    authMode: SIFAuthModes;

    useAdvisory: boolean;

    syncType: string;
    syncAtTime: string;
    syncFailed: number;
    tT_FileID: number;

    active: boolean;
    lastSync: Date;

    immediateSync: boolean;
    runValidation: boolean;

    get type(): string {
        return "SIF";
    }

    get descriptor(): string {
        return `${this.type} Provider - ${this.name}`;
    }

    get user(): string {
        return this.userToken;
    }

    get schema(): string {
        return undefined;
    }

    constructor(data?: Partial<SIFIntegration>) {
        Object.assign(this, data);

        this.providerURL = this.providerURL ?? "";
        this.name = this.name ?? "";
        this.applicationKey = this.applicationKey ?? "";
        this.sharedSecret = this.sharedSecret ?? "";
        this.environmentToken = this.environmentToken ?? "";
        this.sessionToken = this.sessionToken ?? "";
        this.userToken = this.userToken ?? "";
        this.authMode = this.authMode ?? SIFAuthModes.Basic;
        this.active = this.active ?? false;

        if (typeof this.createdOn === "string")
            this.createdOn = new Date(this.createdOn);

        if (typeof this.editedOn === "string")
            this.editedOn = new Date(this.editedOn);

        if (typeof this.recycledOn === "string")
            this.recycledOn = new Date(this.recycledOn);

        if (typeof this.lastSync === "string")
            this.lastSync = new Date(this.lastSync);

        this.syncType = this.active ? "TIME" : "MANUAL";
    }

    clone() {
        return new SIFIntegration(structuredClone(this));
    }
}

export default SIFIntegration;
